const state = {
  newsInfo: {},
  userdata: JSON.parse(window.localStorage.getItem('userdata')) || {
    accountId: null,
    auth: null,
    backgroundImg: null,
    bindstatus: null,
    birthDay: null,
    certificationStatus: null,
    consignee: null,
    contactNo: null,
    couponSum: null,
    email: null,
    gender: null,
    giftSum: null,
    goldAccount: null,
    id: null,
    identityCard: null,
    level: null,
    mUserIcon: null,
    mzAccount: null,
    name: null,
    nickName: null,
    onlyAccount: null,
    phoneNum: null,
    point: null,
    psd: null,
    qq: null,
    realName: null,
    receivedAddress: null,
    recentLoginAddr: null,
    recentLoginIp: null,
    recentLoginTime: null,
    signInToday: null,
    signInWhatDay: null,
    signature: null,
    upgradePoint: null,
    wx: null,
  },
  token: JSON.parse(window.localStorage.getItem('token')) || '',
  game: JSON.parse(window.localStorage.getItem('game')) || [],
  show: false
}
export default state



// WEBPACK FOOTER //
// ./src/store/state.js